<template>
  <svg xmlns="http://www.w3.org/2000/svg" data-name="crown-solid copy 2" width="24" height="19" viewBox="0 0 24 19">
    <path id="Shape" :fill="color" d="M19.8,19H4.2a.6.6,0,0,1-.6-.594V17.219a.6.6,0,0,1,.6-.594H19.8a.6.6,0,0,1,.6.594v1.187A.6.6,0,0,1,19.8,19Zm-.6-3.562H4.8L2.089,8.283a1.819,1.819,0,0,1-.289.03,1.781,1.781,0,1,1,0-3.562A1.793,1.793,0,0,1,3.6,6.531a1.771,1.771,0,0,1-.165.734L6.15,8.877a1.207,1.207,0,0,0,1.658-.43l3.056-5.292A1.77,1.77,0,0,1,10.2,1.781a1.8,1.8,0,0,1,3.6,0,1.769,1.769,0,0,1-.663,1.373l3.056,5.292a1.206,1.206,0,0,0,1.657.43l2.715-1.611a1.728,1.728,0,0,1-.165-.734,1.845,1.845,0,1,1,1.511,1.751L19.2,15.437Z" />
  </svg>
</template>
<script>
export default {
  name: 'IconSearch',
  props: {
    color: {
      type: String,
      default: '#f8e71c'
    }
  }
};
</script>
